module.exports = {"id":"186905","name":"Ashley Barnes","rating":"76","photo":"./data/images/photos/4/186905.png","club":{"name":"Burnley","logo":"./data/images/clubs/Burnley.png"},"positions":["BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AshleyBarnes0.json
// module id = 486
// module chunks = 0